import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const VoiceBotTemplateInfo: React.FC = () => {
	return (
		<Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
			<>
				<Typography variant="subtitle1" gutterBottom>
					Required Excel Columns
				</Typography>
				<Box 
					sx={{ 
						display: 'flex',
						border: '1px solid',
						borderColor: 'grey.300',
						borderRadius: 0,
						overflowX: 'auto',
						overflowY: 'hidden'
					}}
				>
					<Box
						key='client_reference_id'
						sx={{
							flexShrink: 0,
							minWidth: '100px',
							bgcolor: 'grey.200',
							borderRight: '1px solid',
							borderColor: 'grey.300',
							textAlign: 'center',
							py: 1,
							px: 1,
							fontSize: '0.8125rem',
							whiteSpace: 'nowrap'
						}}
					>
						client_reference_id
					</Box>
					<Box
						key='contact_number'
						sx={{
							flexShrink: 0,
							minWidth: '100px',
							bgcolor: 'grey.200',
							borderRight: 'none',
							borderColor: 'grey.300',
							textAlign: 'center',
							py: 1,
							px: 1,
							fontSize: '0.8125rem',
							whiteSpace: 'nowrap'
						}}
					>
						contact_number
					</Box>
				</Box>
			</>
		</Paper>
	);
};

export default VoiceBotTemplateInfo;
